import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AssetViewDtoServiceConfig = {
  name: "AssetViewDto",
  annotations: []
} as ServiceConfig;